import React from 'react';
import styles from './index.module.scss';

const BackButton = () => {
  return (
    <div className={styles['back-button']} onClick={() => window.history.back()}>
      <i className='fa fa-arrow-left' />
        Back
    </div>
  );
};

export default BackButton;